module.exports = __webpack_public_path__ + "img/scirocco.76c9dd90.jpg";